import { useEffect, useState } from "react"
import { Box, Button, Dialog, DialogContent, DialogTitle } from "@mui/material"
import { toast } from "sonner"
import { defaultHeaders } from "@/hooks/apiFetch"

type BillImagePreviewProps = {
  expenseId: number
}

export default function BillImagePreview({ expenseId }: BillImagePreviewProps) {
  const [imageUrl, setImageUrl] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    return () => {
      if (imageUrl) URL.revokeObjectURL(imageUrl)
    }
  }, [imageUrl])

  const openImage = async () => {
    setLoading(true)
    try {
      const response = await fetch(
        `${import.meta.env.VITE_BASE_URL}/expense/${expenseId}/bill-image`,
        { headers: defaultHeaders() }
      )
      if (!response.ok) throw new Error("Could not load the bill image")

      setImageUrl(URL.createObjectURL(await response.blob()))
    } catch {
      toast.error("Could not load the bill image")
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Button size="small" onClick={openImage} disabled={loading}>
        {loading ? "Loading…" : "View bill"}
      </Button>
      <Dialog
        open={Boolean(imageUrl)}
        onClose={() => setImageUrl(null)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Expense bill</DialogTitle>
        <DialogContent>
          {imageUrl && (
            <Box
              component="img"
              src={imageUrl}
              alt="Expense bill"
              sx={{
                display: "block",
                maxWidth: "100%",
                maxHeight: "75vh",
                mx: "auto",
              }}
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  )
}
